import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { Stack } from "@mui/material";

import React from "react";

const SIZE = 32;

export const DoneSmallIcon = () => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{
      backgroundColor: "#00A507",
      borderRadius: "50%",
      height: SIZE,
      width: SIZE,
      minWidth: SIZE,
      minHeight: SIZE,
      flexShrink: 0,
    }}
  >
    <DoneRoundedIcon sx={{ color: "#FFF" }} />
  </Stack>
);
